















import { Vue, Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import * as api from "../api";
import { tree, cc } from "../utils";
import FormRows from "../parts/FormRows";
import { InputRow } from "../models";
import App from '../App'
import { shuffle, sleep, normalizeModel, bakeRemoteData } from '../utils'
import SelectNode from '../parts/SelectNode'
import { remoteOp } from "../helper";

type Model = {id: number, name: string, is_active: number, create_time: number, update_time: number}

@Component({
  components: { FormRows },
})
export default class UserUpdate extends Vue {
  @Prop() callbacks: {
    append: (data) => void;
    update: (id, data) => void;
  }

  @Prop() list: Model[];

  id = 0

  model = { name: '', password: '', confirmPassword: '', is_active: 0}

  busy = false

  inputs: InputRow[] = [
    { widget: 'text', key: 'name', label: '用户名' },
    { widget: 'password', key: 'password', label: '密码' },
    { widget: 'password', key: 'confirmPassword', label: '确认密码' },
    { widget: 'checkbox', key: 'is_active', label: '是否激活' },
  ]

  created() {
    this.reset()
  }

  @Watch('$route')
  $routeChanged() {
    if (this.$route.name === 'user-update') {
      this.reset()
    }
  }

  private reset() {
    this.busy = false
    let item = this.list.find(n => n.id == parseInt(this.$route.params.id))
    if (item) {
      this.id = item.id
      this.model.name = item.name
      this.model.is_active = parseInt(item.is_active.toString())
    }
  }

  save() {
    if (!this.id) {
      return
    }
    let name = this.model.name.trim()
    let password = this.model.password.trim()
    let confirmPassword = this.model.confirmPassword.trim()
    if (!name) {
      alert('请填写用户名')
      return
    }
    if (password || confirmPassword) {
      if (password !== confirmPassword) {
        alert('密码与确认密码不一致')
        return
      }
    }
    $(':focus', this.$el).blur()
    remoteOp(this, '保存', '', async () => {
      let result = await api.invoke('user/update', this.id, this.model.name, this.model.is_active, this.model.password)
      this.close()
      this.callbacks.update(this.id, result)
    })
  }

  close() {
    this.$router.replace({ name: 'user-list' })
  }
}
